import timestampedResources from './tools.json' with { type: 'json' };
export default timestampedResources;
